"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyDynamicAtlasLoader = void 0;
const WebGLGameObjectAtlas_1 = require("../TextureAtlases/WebGLGameObjectAtlas");
const CanvasGameObjectAtlas_1 = require("../TextureAtlases/CanvasGameObjectAtlas");
const utils_1 = require("../../../utils");
const Gottimation_1 = require("../../Gottimation");
class LazyDynamicAtlasLoader {
    constructor(atlases, indexedDbLoader, projectPath, renderer, preloadedSkins) {
        this.slotIdToRectLookup = {};
        this.slotIdToColliderLookup = {};
        this.slotIdToTagLookup = {};
        this.atlasNameToSkinNameToSlotTextures = {};
        this.atlasNameToSlots = {};
        this.loadedSkins = {};
        this.loader = indexedDbLoader;
        this.projectPath = projectPath;
        if (renderer.type == 1) {
            this.textureAtlas = new WebGLGameObjectAtlas_1.WebGlGameObjectAtlas(renderer);
        }
        else {
            this.textureAtlas = new CanvasGameObjectAtlas_1.CanvasGameObjectAtlas(renderer);
        }
        // used so if we have a bunch of slots with the same tags we can reuse the same array ref.
        const tagArraysAddedSoFar = [];
        atlases.forEach(a => {
            this.atlasNameToSkinNameToSlotTextures[a.name] = {};
            this.atlasNameToSlots[a.name] = Object.keys(a.slots).map(s => {
                return isNaN(parseInt(s)) ? s : parseInt(s);
            });
            for (let slotId in a.slots) {
                if (a.slots[slotId].cuids) {
                    this.slotIdToColliderLookup[slotId] = a.slots[slotId].cuids.map(cuid => {
                        return a.colliders[cuid];
                    });
                }
                this.slotIdToRectLookup[slotId] = a.slots[slotId].rect;
                if (a.slots[slotId].tags) {
                    const arrayHash = a.slots[slotId].tags.sort().join(',');
                    const found = tagArraysAddedSoFar.find(a => a.hash == arrayHash);
                    if (found) {
                        this.slotIdToTagLookup[slotId] = found.array;
                    }
                    else {
                        const array = [...a.slots[slotId].tags];
                        tagArraysAddedSoFar.push({ hash: arrayHash, array });
                        this.slotIdToTagLookup[slotId] = array;
                    }
                }
            }
        });
        if (preloadedSkins) {
            preloadedSkins.forEach(({ atlasName, texture, skinId }) => {
                this._getSkinFromTexture(atlasName, texture, skinId);
            });
        }
    }
    updateAtlas(atlasData) {
    }
    removeAtlas(atlasData) {
    }
    removeSkin(atlasName, skinName) {
    }
    loadSheet(sheetId) {
        return Promise.resolve(undefined);
    }
    loadSkinTexture(url) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield this.loader.loadImageData(url);
            // console.log('finna get:', data);
            if (!data) {
                data = (yield utils_1.httpGetAsync(url, false));
                if (data) {
                    this.loader.saveImageData(url, data);
                }
            }
            const finalTexture = data ? yield utils_1.getTextureFromBlob(data) : null;
            return finalTexture;
        });
    }
    addToAtlas(texture) {
        return texture;
    }
    getOpenBaseTexture() {
        return { baseTexture: null, x: 0, y: 0 };
    }
    splitTextureAndAddToMap(atlasName, skinId, texture) {
        const { texture: atlasedTexture, rect } = this.textureAtlas.addTexture(`${atlasName}_${skinId}`, texture, null, true);
        const atlasSkinLookup = this.atlasNameToSkinNameToSlotTextures[atlasName];
        for (let i = 0; i < this.atlasNameToSlots[atlasName].length; i++) {
            const slotId = this.atlasNameToSlots[atlasName][i];
            const slotRect = this.slotIdToRectLookup[slotId];
            //   console.log('its going to become', rect.x + slotRect[0]-1,  rect.y + slotRect[1]-1, slotRect[2], slotRect[3])
            // console.log('slot rect:', slotRect, 'rect', rect, rect.x + slotRect[0], rect.y + slotRect[1], slotRect[2], slotRect[3]);
            // @ts-ignore
            //TODO: i had code that was subtracting 1 from slotRect[0] and slotRect[1], the bounds was out for the texture and was having an issue, have to see whats up with that. editor might be off by a pixel.
            atlasSkinLookup[skinId][slotId] = new PIXI.Texture(atlasedTexture, new PIXI.Rectangle(rect.x + slotRect[0], rect.y + slotRect[1], slotRect[2], slotRect[3]));
        }
        return atlasSkinLookup[skinId];
    }
    _getSkinFromTexture(atlasName, texture, id) {
        const atlasSkinLookup = this.atlasNameToSkinNameToSlotTextures[atlasName];
        if (id in atlasSkinLookup) {
            throw new Error(`Already had id ${id}`);
        }
        atlasSkinLookup[id] = {};
        return this.splitTextureAndAddToMap(atlasName, id, texture);
    }
    _getOrLoadSkinFromUrl(atlasName, skinUrl, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const atlasSkinLookup = this.atlasNameToSkinNameToSlotTextures[atlasName];
            id = id || id === 0 || id === '0' ? id : skinUrl;
            if (id in atlasSkinLookup) {
                return atlasSkinLookup[id];
            }
            let texture = yield this.loadSkinTexture(skinUrl);
            if (!texture)
                throw new Error(`Could not load skin from url: ${skinUrl}`);
            atlasSkinLookup[id] = {};
            return this.splitTextureAndAddToMap(atlasName, id, texture);
        });
    }
    getSlotsForTexture(t, atlasName, tag) {
        var _a;
        const lookup = {};
        const texture = t instanceof PIXI.BaseTexture ? t : t.baseTexture;
        for (let i = 0; i < this.atlasNameToSlots[atlasName].length; i++) {
            const slotId = this.atlasNameToSlots[atlasName][i];
            if (!tag || ((_a = this.slotIdToTagLookup[slotId]) === null || _a === void 0 ? void 0 : _a.includes(tag))) {
                const slotRect = this.slotIdToRectLookup[slotId];
                lookup[slotId] = new PIXI.Texture(texture, new PIXI.Rectangle(slotRect.x, slotRect.y, slotRect.w, slotRect.h));
            }
        }
        return lookup;
    }
    slotHasTag(slotId, tag) {
        const tags = this.slotIdToTagLookup[slotId];
        if (!tags)
            return false;
        return this.slotIdToTagLookup[slotId].includes(tag);
    }
    getSkinSlots(atlasName, skinName) {
        return this.atlasNameToSkinNameToSlotTextures[atlasName][skinName];
    }
    getSkinSlot(atlasName, skinName) {
        return this.atlasNameToSlots[atlasName][skinName];
    }
    loadSkinSlots(atlasName, skinName) {
        return __awaiter(this, void 0, void 0, function* () {
            skinName = skinName ? skinName : Gottimation_1.DEFAULT_SKIN_ID;
            if (!skinName.includes('.png')) {
                skinName = skinName + '.png';
            }
            const url = `${this.projectPath}/atlases/${atlasName}/skins/${skinName}`;
            return this._getOrLoadSkinFromUrl(atlasName, url, skinName);
        });
    }
    loadSkinSlotsByUrl(atlasName, url) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._getOrLoadSkinFromUrl(atlasName, url);
        });
    }
}
exports.LazyDynamicAtlasLoader = LazyDynamicAtlasLoader;
//# sourceMappingURL=module.js.map